import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let QuickSuggestionsOption: LazyOption = createLazyOption(
    {
        key: 'quickSuggestions',
        titleStringKey: 'optionTitle_quickSuggestions',
        searchTermsStringKey: 'optionTitle_quickSuggestions',
    },
    lazyFullModule,
    m => m.default
);
export default QuickSuggestionsOption;
